import Vue from 'vue';
import Component from 'vue-class-component';
import { localize } from 'vee-validate';
import publicPathModule from '@/store/modules/iti-public-path.module';
import { i18n, ItiString } from '@/iti-core-vue';

@Component({})
export default class ItiLanguageSelector extends Vue {

  public get languageSelected() {
    return i18n.locale;
  }

  public get flagSrc(): string {
    return this.pathFlag(this.languageSelected);
  }

  public get languages() {
    const languages: string[] = [];
    for (const key in i18n.messages) {
      if (key) {
        languages.push(key as string);
      }
    }
    return languages;
  }

  public changeLanguage(newLanguage: string) {
    // Cambiamos el idioma
    i18n.locale = newLanguage;

    // Cambiamos el idioma de los mensajes de validación
    // Nota: los mensajes en 'en' los lleva por defecto, no hay que volver a cargalos.
    //       los mensajes en 'es' los cargó en el main.ts, no hay que volver a pasarselos como parámetro.
    localize(newLanguage);

    this.$emit('onChangeLanguage', newLanguage);
  }

  protected pathFlag(flag: string): string {
    return ItiString.IsNullOrWhiteSpace(publicPathModule.publicPath)
      ? ItiString.Empty
      : publicPathModule.publicPath + 'assets/flags/' + flag + '.png';
  }
}

